import {
  takeLatest, takeEvery, put, call, all,
} from 'redux-saga/effects';
import * as actions from '@actions/risk-record';
import Message from '@rootCommon/services';
import RiskRecordService from '@rootCommon/services/risk-record-service';
import { RiskRecord } from '@rootTypes/cancerRisk';
import { AxiosError } from 'axios';
import { SagaGenerator } from './index';

// fetch
function* fetchRiskRecordAsync() {
  try {
    const riskRecord: RiskRecord = yield call(RiskRecordService.getAdminRiskRecord);

    yield put(actions.fetchRiskRecord.success(riskRecord));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.fetchRiskRecord.failure(error));
  }
}

function* watchFetchRiskRecord() {
  yield takeLatest(actions.fetchRiskRecord.request, fetchRiskRecordAsync);
}

// update
function* updateRiskRecordAsync(action: { payload: RiskRecord }) {
  try {
    yield call(RiskRecordService.updateAdminRiskRecord, action.payload);
    yield put(actions.updateRiskRecord.success(action.payload));
    Message.success('Risk Threshold updated successfully');
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.updateRiskRecord.failure(error));
  }
}

function* watchUpdateRiskRecord() {
  yield takeEvery(actions.updateRiskRecord.request, updateRiskRecordAsync);
}

// all
function* watchRiskRecord(): SagaGenerator {
  yield all([watchFetchRiskRecord(), watchUpdateRiskRecord()]);
}

export default watchRiskRecord;
